const CLOUD_NAME = 'dvbwv2xqy'
const UPLOAD_PRESET = 'mayo-express'
const MAX_SIZE = 2 * 1024 * 1024 // 2 MB

export async function uploadToR2(
  file: File,
  folder: 'productos' | 'qr'
): Promise<string> {
  if (file.size > MAX_SIZE) throw new Error('El archivo supera los 2 MB')

  const body = new FormData()
  body.append('file', file)
  body.append('upload_preset', UPLOAD_PRESET)
  body.append('folder', `mayo-express/${folder}`)

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
    { method: 'POST', body }
  )

  if (!res.ok) throw new Error('Error al subir imagen')
  const data = await res.json()
  return data.secure_url as string
}
